import { Injectable } from '@angular/core';
import { environment as env } from "../../../../../environments/environment.prod";
import { HttpClient } from '@angular/common/http';
import { AbstractService } from 'app/services/abstract.service';
import ReasonRejectionTypeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/masters/reason-rejection-types/types-reason-rejection.entity';
import { ICreateRejectionType } from './interfaces/create-rejection-type.interface';
import { IUpdateRejectionType } from './interfaces/update-rejection-type.interface';
import { 
  andAllWhere,
  andWhere, 
  buildQuery, 
  Ops, 
  OrderVariant, 
  select,
  page, 
  where,
  noop,
  orderBy,
  orWhere
} from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";
import { Observable } from 'rxjs';
import { IPagination, IPaginationResult, IRequestResult } from 'app/common/interfaces';


const apiUrl = env.API_UNIT_MEASURE;
const moduleName = "reason_rejection_types";

@Injectable({
  providedIn: 'root'
})
export class RejectionTypeService extends AbstractService<
  ReasonRejectionTypeAttributes,
  ICreateRejectionType,
  IUpdateRejectionType
>  {

  constructor(
      http: HttpClient,
    ) {
      super(apiUrl, moduleName, http);
    }
  
  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */

  findAllWithCount(
    options: IPagination<ReasonRejectionTypeAttributes> & { status?: number[] }, 
    companyIds: number[]
  ): Observable<IPaginationResult<ReasonRejectionTypeAttributes>> {
    const query = buildQuery<ReasonRejectionTypeAttributes>(
          where('_deleted', Ops.eq(false)),
          andWhere("id", Ops.like(options.search ?? "", "i")),
          orWhere("name", Ops.like(options.search ?? "", "i")),
          companyIds && companyIds.length > 0 ? andAllWhere('company.id' as keyof ReasonRejectionTypeAttributes, Ops.in(...companyIds)) : noop(),
          options.status && options.status.length > 0 ? andAllWhere('statusId', Ops.in(...options.status)) : noop(),
    
          orderBy(
            options.sort ?? "name",
            options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
          ),
          page(options.currentPage ?? 1, options.limitPerPage ?? 100)
        );
    
        const API_URL: string =
          apiUrl +
          `api/${moduleName}/withCount?filter=${encodeURIComponent(JSON.stringify(query))}`;
        return this.http.get<IPaginationResult<ReasonRejectionTypeAttributes>>(API_URL);
  }

  /**
   * Find to combo box
   * @returns Data
  */
  findToComboBox(): Observable<IRequestResult<ReasonRejectionTypeAttributes[]>> {
    const query = buildQuery<ReasonRejectionTypeAttributes>(
      where("statusId", StatusEnum.ACTIVE),
      select(["id", "code", "name"]),
      //orderBy("id", OrderVariant.Asc)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/filter?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IRequestResult<ReasonRejectionTypeAttributes[]>>(API_URL);
  }

  filterComboBox(){}
}
